import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs';
import { ToolbarDTO } from '../../../shared/toolbar-dto';


@Injectable({
  providedIn: 'root'
})
export class ToolbarService {
  toolbarDTO: ToolbarDTO[] = [] as ToolbarDTO[]
  toolbarSubject: Subject<ToolbarDTO[]> = new Subject<ToolbarDTO[]>();

  constructor(private http: HttpClient) {
    this.toolbarSubject.subscribe(toolbar => this.toolbarDTO = toolbar);
    this.getToolbar();
  }

  getToolbar(isWholesale?: boolean, force?: boolean) {
    let extraData = `${isWholesale ? 'is_wholesale=1&' : ''}`
    extraData += `${force ? 'refresh=true' : ''}`
    this.http.get<ToolbarDTO[]>(`/api/toolbar?${extraData}`)
    .subscribe(toolbar => this.toolbarSubject.next(toolbar))
  }
}
